// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"04690aa2","239":"78dab9fc","455":"8ccb3562","488":"5f0cb1c0"}[chunkId] + ".chunk.js";
};